import React, { useEffect, useRef } from 'react';
import { useInViewport } from 'ahooks';
import { useTracker } from '@archipro-website/tracker';

interface DetailShellSectionProps {
    children?: React.ReactNode;
    isAd?: boolean;
    percentContentViewed: number;
    moduleId?: string;
}

/**
 * Wrapper component for `DetailModule` (Page Builder module) which contains
 * tracking logic.
 */
const DetailSection = ({
    children,
    isAd,
    percentContentViewed,
    moduleId,
}: DetailShellSectionProps) => {
    const tracker = useTracker();
    const moduleRef = useRef<HTMLDivElement>(null);

    const [inView] = useInViewport(moduleRef);
    const eventFired = useRef(false);

    useEffect(() => {
        if (!inView || eventFired.current) return;
        tracker.log('PageModuleViewed', {
            url: new URL(window.location.href),
            targetTracker: ['archiproTracker', 'ga4Tracker'],
            data: {
                ExtraData: percentContentViewed,
            },
            ga4Data: { percentContentViewed },
        });
        eventFired.current = true;
    }, [inView, tracker, percentContentViewed, eventFired]);

    // The 'ad-section' class is crucial for the Resene colour picker to correctly identify and differentiate ad sections from content sections.
    return (
        <section
            ref={moduleRef}
            id={moduleId}
            className={isAd ? 'ad-section' : '!h-min'}
        >
            {children}
        </section>
    );
};

export default DetailSection;
